import { checkMenuAccess } from "@utils/menu-auth";
import React from "react";
import AttendanceTemplate from "./attendance.template";

const menuUrl = "admin-module/attendance/test";

const AttendanceComponent = () => {
  const menuAccess = checkMenuAccess(menuUrl, "read");
  // console.log({ menuAccess, menuUrl });
  return <AttendanceTemplate />;
};

export default AttendanceComponent;
